export const emptyFilter = {
  type: "combined",
  conditionType: "AND",
  conditions: [
    {
      type: "combined",
      conditionType: "AND",
      conditions: [],
    },
    {
      type: "combined",
      conditionType: "OR",
      conditions: [],
    },
  ],
};
